import React, { useEffect, useState } from "react";
import Models from "../../main-page/components/get-conversation/Models";
import SideBar from "../components/SideBar";
import { useAppDispatch, useAppSelector } from "../../../store/hooks";
import { setAnonymousToken } from "../../../store/account/userSlice";
import { useLoginAnonymous } from "../../../store/Apis/UserApi";
import Navbar from "../../main-page/components/get-conversation/Navbar";
import { Outlet } from "react-router-dom";
export const LandingPage = () => {
  const dispatch = useAppDispatch();
  const User = useAppSelector((s) => s.User);
  const [showClosedChatsModeModal, setShowClosedChatsModeModal] =
    useState(false);

  const { data: LoginAnonymousToken, isSuccess } = useLoginAnonymous();

  useEffect(() => {
    if (isSuccess && !User.IsAuthenticated) {
      dispatch(setAnonymousToken(LoginAnonymousToken));
    }
  }, [isSuccess]);

  return (
    <>
      <SideBar />
      <div className="flex-grow-1">
        <Navbar
          setShowClosedChatsModeModal={setShowClosedChatsModeModal}
          showClosedChatsModeModal={showClosedChatsModeModal}
        />
        {!window?.location?.pathname.includes("/suites") && !window?.location?.pathname.includes("/library")&&
        !window.location.pathname.includes("/workflows") ? (
          isSuccess && <Models page="Landing-page" />
        ) : (
          <Outlet />
        )}
      </div>
    </>
  );
};
